$('#shopify-section-product-template').on('click', '.btn--add', function(evt) {
    evt.preventDefault();
    var order_quantity = $(this).parent().siblings().children(':input[type="number"]').val();
    var variant_id = $(this).attr("id");
    var variant_name = $(this).attr("name");
    var assemble_id = "26271478546532";
    var assemble_count = "1";
    var hinge_option_value = null;
    $(this).html("Added");

    var hinge_elem = $(this).parent().siblings().children('input.hinge-position-radio:checked') ; 
    if (hinge_elem.length > 0 ) {
        hinge_option_value = hinge_elem.val();
    }

    function add_assemble_to_cart() {
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: {
                quantity: order_quantity,
                id: assemble_id,
                properties: {
                    'For': variant_name,
                    '_Assemble_Associated_ID': variant_id
                }
            },
            success: function(response) { setTimeout(function() { location.reload(); }, 2000); }
        });
    }
    if ($(this).parent().siblings().children(':input[type="checkbox"]').is(':checked')) {
        if (hinge_option_value) {
            properties_hash = {'_Need_Assemble_ID': assemble_id, '_Hinge_Install_Position': hinge_option_value };
        } else {
            properties_hash = {'_Need_Assemble_ID': assemble_id };
        } ;
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: {
                quantity: order_quantity,
                id: variant_id,
                properties: properties_hash
            },
            success: function(response) { 
//                 setTimeout(function() { location.reload(); }, 2000);
                add_assemble_to_cart();
            }
        });
    } else {
        // If no assemble option is checked, just add product
        if (hinge_option_value) {
            properties_hash = {'_Hinge_Install_Position': hinge_option_value };
        } else {
            properties_hash = { };
        } ;
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: {
                quantity: order_quantity,
                id: variant_id,
                properties: properties_hash
            },
            success: function(response) { setTimeout(function() { location.reload(); }, 2000); }
        });
    }
});

$('.checkbox_check').on('click', function() {
    $(this).parent().siblings().children('.assemble_product_price_display').toggle();
    if($(this).prop('checked') == true) {
        $(this).parent().siblings().children('input.hinge-position-radio').prop('disabled', false);
        $(this).parent().siblings().children('input.hinge-position-radio[value=left]').prop('checked', true);
        $(this).parent().siblings().children('label').css('opacity', 1);
    } else {
        $(this).parent().siblings().children('input.hinge-position-radio').prop('checked', false);
        $(this).parent().siblings().children('input.hinge-position-radio').prop('disabled', true);
        $(this).parent().siblings().children('label').css('opacity', 0.1);
    }
});


function remove_item_only(item_id_or_key) {
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: {
            quantity: 0,
            id: item_id_or_key
        },
        success: function(cart) {
            location.reload();
            return true;
        },
        error: function(data) {
            console.log('Remove item error, please contact our store.');
        }
    });
}

function remove_assemble_and_item(line_id, item_id) {
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: {
            quantity: 0,
            line: line_id
        },
        success: function(cart) {
            remove_item_only(item_id);
            return true;
        },
        error: function(data) {
            console.log('Remove item and assemble error, please contact our store.');
        }
    });
}


$('.remove_btn').on('click', function() {
  var item_id = $(this).attr('id');
  var item_key = $(this).attr('key');
  $.ajax({
    url: '/cart.js',
    dataType: 'json',
    success: function(cart) {
      var associatedRemove = false;
      cart.items.forEach( function(item, idx) {
        var item_properties = item.properties;
        if (item_properties != null && "_Assemble_Associated_ID" in item_properties ) {
          for_main_product_id = item_properties._Assemble_Associated_ID;
          if (for_main_product_id == item_id) {
            associatedRemove = true;
            // shopify item order in cart is 1-based; while forEach is 0-based
            remove_assemble_and_item(idx+1, item_id);
          }
        }
      });
      // If we can't find an assemble item for this item, either 
      //  a) this is assemble, and there might be multiple assemble (need to use item_key to delete)
      //  b) this is item without assemble selection, still use item_key to delete
      if (associatedRemove == false) {
        remove_item_only(item_key);
      }
    } // end success
  }); // end ajax
});

// recode collection page to correctly show thumbnail images when clicking it
$('div.product-card.CollectionListSection a.text-link.product-single__thumbnail.product-single__thumbnail--product-template').on('click', function(evt) {
  evt.preventDefault();
  var image_id = $(this).attr('data-thumbnail-id');
  var parent_div = $(this).closest("div.product-card.CollectionListSection");
  $(parent_div).find("div.product-single__photo.js-zoom-enabled.product-single__photo--has-thumbnails").each(function() {
    var div_id = $(this).attr('id');
    var last_id = div_id.split("-").pop(-1);
    if (image_id == last_id) {
      $(this).removeClass('hide');
      $(this).show();
    } else {
      $(this).hide();
    }
  });
});


$('#trackingOrderForm input.btn.tracking-submit').on('click', function(evt) {
  evt.preventDefault();
  var search_type = $("input[name='search_type']").val();
  var search_key = $("input[name='search_key']").val();
  var name = $("input[name='name']").val();
  var email = $("input[name='email']").val();
  var phone = $("input[name='phone']").val();
  console.log("clicked button, no email sent out..., search_key = " + search_key);
  if (search_key.length < 6) {
    alert("Please input valid order number before searching..."); 
    return false;
  }
  if (search_key && name && email && phone ) {
	window.location.href = "https://newship.webhost168.com/home/search?search_params[search_type]="+search_type+"&search_params[search_key]="+search_key+"&search_params[email]="+email+"&search_params[phone]="+phone+"&search_params[name]="+name;
  } else {
    alert("Please input all required fields before search order..."); 
  }
  
  return false;
});
